import React, { useEffect, useState  } from "react";
import { useNavigate } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRightFromBracket, faBars } from '@fortawesome/free-solid-svg-icons';

import { auth, logout, getData } from "../../configs/firebase";
import { onAuthStateChanged } from "firebase/auth";

import LodingIndicator from "../../components/LoadingIndicator"
import { IMAGES } from "../../constants/index"
import NOTION from "../../constants/notion"
import { CAMPAIGN_DATE } from "../../constants/constants"

import './ByFaithPage.css';


function ByFaithPage(){
    let navigate = useNavigate();

    const [user, setUser] = useState(null);
    const [data, setData] = useState(null);
    const [opacity, setOpacity] = useState(0);
    const [dayIndex,setDayIndex] = useState(null)
    const [isLoaded, setIsLoaded] = useState(false);

    // 🔹 로그인 상태 감지
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            if(currentUser) setUser(currentUser);
            else handlelogout()
        });
        return () => unsubscribe();
    }, []);

    // 🔹 첫 시작 시 페이드 인 적용
    useEffect(() => {
        if(user){
            getUserData()
        }
    }, [user]);

    useEffect(() => {
        if(dayIndex!=null&&data!=null){
            validateDate(data.lastestUpdateDate)
        }
    }, [dayIndex,data]);

    const getUserData = async () => {
        const data = await getData(user.uid)
        setDayIndex(Object.keys(data[0]?.checkList || {}).length);
        setData(data[0])
        if(Object.keys(data[0]?.checkList || {}).length===8){
            if(!data[0].event.epilogue)handleNavigation('/epilogue')
            else handleNavigation('/myFaith')
        }
    }
    
    const handleCheckList = async() => {
        setOpacity(0); // 🔥 페이드 아웃 시작
        setTimeout(() => {
            handleNavigation('/checkList')
        }, 2000);
    }

    const handlelogout = async() => {
        const isConfirmed = window.confirm("로그아웃 하시겠습니까?");
        if (isConfirmed) {
            try{
                const result = await logout()
                navigate('/login');
            } catch (e) {
                console.error("로그아웃에 실패했습니다.", e)
            }
        }
    }
    const handleNavigation = (addrss) => {
        navigate(addrss);
    }
    

    function ExternalPage(addrss) {
        // console.log(NOTION,dayIndex,NOTION[dayIndex],addrss)
        return (
            <div style={{ width: "100%", height: "100%" }}>
                {!isLoaded && (
                    <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", fontSize: "18px", color: "#555" }}>
                        <LodingIndicator visiblity={true} color={"#131835"} />
                    </div>
                )}
                <iframe src={addrss} width="100%" height="100%" frameborder="0" onLoad={() => setIsLoaded(true)} allowfullscreen />
            </div>
        );
    }
    function validateDate(updatedDate) {
        if (!updatedDate) {
            setOpacity(1);
            return false;
        }

        // 🔹 1. 한국 시간(KST) 기준 오늘 날짜 가져오기
        const today = new Date().toLocaleDateString("ko-KR", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        }).replace(/. /g, "-").replace(".", ""); // ✅ "2025-02-22" 형식으로 변환
    
        const updatedDateString = updatedDate.split(" ")[0].replace(/. /g, "-").replace(".", "");
        // console.log(dayIndex,today,updatedDateString,CAMPAIGN_DATE[dayIndex],today == updatedDate,updatedDate == CAMPAIGN_DATE[dayIndex-1])
        
        // 🔹 3. 날짜 비교 후 결과 반환
        if (today == updatedDateString && updatedDateString == CAMPAIGN_DATE[dayIndex-1]) {
            // console.log("✅ 최신!");
            let url;
            // console.log(data, Object.keys(data?.checkList || {}).length,Object.keys(data?.rhema || {}).length)
            if(Object.keys(data?.checkList || {}).length === Object.keys(data?.rhema || {}).length) url='/myFaith';
            else url = '/rhema'

            setOpacity(0);
            setTimeout(() => {
                handleNavigation(url)
            }, 2000);
            return true;
        } else {
            // if(dayIndex===4) {
            //     let url;
            //     // console.log(data, Object.keys(data?.checkList || {}).length,Object.keys(data?.rhema || {}).length)
            //     if(Object.keys(data?.checkList || {}).length === Object.keys(data?.rhema || {}).length) url='/myFaith';
            //     else url = '/rhema'
    
            //     setOpacity(0);
            //     setTimeout(() => {
            //         handleNavigation(url)
            //     }, 2000);
            //     return true;
            // }
            setTimeout(() => {
                setOpacity(1);
            }, 500); // 0.5초 후 페이드 인
        }
    }
// 3eZ0X83ydi6vFeAUVkuZ
    return (
        <div
            className="wrap"
            style={{
                backgroundImage: `url(${IMAGES.BACKGROUMND})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                width: "100vw",
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <div className="byFaithWrap" style={{ opacity, transition: "opacity 1s ease-in-out" }}>
                <div className="contentsTitle">
                    <span className="iconButton">
                    </span>
                    <span>{NOTION[dayIndex]?.name||null}</span>
                    <span className="iconButton" onClick={handlelogout}>
                        <FontAwesomeIcon className="iconBtn" icon={faRightFromBracket} style={{color:"#131835"}}/>
                    </span>
                </div>
                <div className="contents">
                    {ExternalPage(NOTION[dayIndex]?.address)}
                </div>    
                <div className="contentsButton">
                    <span onClick={handleCheckList}>믿음 체크하기</span>
                </div>       
            </div>
        </div>
    );
  }
  export default ByFaithPage;